import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CalendarDays } from "lucide-react";
import { api } from "@/lib/api";
import { tanggal } from "@/lib/format";
import { PublicPage } from "@/components/landing/PublicPage";
import { TONE } from "@/components/landing/AnnouncementsSection";

export default function PengumumanDetail() {
  const { id } = useParams();
  const [a, setA] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get(`/announcements/${id}`).then((r) => setA(r.data)).catch(() => setError("Pengumuman tidak ditemukan atau sudah tidak aktif."));
  }, [id]);

  return (
    <PublicPage testId="pengumuman-detail-page" eyebrow="Pengumuman" title={a?.title || (error ? "Tidak ditemukan" : "Memuat...")} back="/pengumuman" backLabel="Semua pengumuman">
      {error ? (
        <p className="text-red-700" data-testid="pengumuman-detail-error">{error}</p>
      ) : a && (
        <article className="max-w-3xl rounded-3xl bg-white border border-emerald-900/10 p-8" data-testid="pengumuman-detail">
          <div className="flex flex-wrap items-center gap-3 text-sm">
            <span className={`text-[11px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full ${TONE[a.priority] || TONE.normal}`}>{a.priority}</span>
            <span className="inline-flex items-center gap-1 text-slate-500"><CalendarDays size={14} /> {tanggal(a.created_at?.slice(0, 10))}</span>
          </div>
          <p className="mt-6 text-base text-slate-700 leading-relaxed whitespace-pre-line" data-testid="pengumuman-detail-content">{a.content}</p>
        </article>
      )}
    </PublicPage>
  );
}
